import { createFileRoute } from '@tanstack/react-router'
import ReportList from '../pages/ReportList'
import '../styles/main.css'

export const Route = createFileRoute('/')({
  component: () => <ReportList />,
})
